import { render, staticRenderFns } from "./b-toggle-switch.vue?vue&type=template&id=83d9ab5e&scoped=true"
import script from "./b-toggle-switch.vue?vue&type=script&lang=js"
export * from "./b-toggle-switch.vue?vue&type=script&lang=js"
import style0 from "./b-toggle-switch.vue?vue&type=style&index=0&id=83d9ab5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d9ab5e",
  null
  
)

export default component.exports